import React from 'react';

function PlugSolid(props) {
  return (
    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g transform="matrix(0.016,0,0,0.016,0,0)">
        <path
          d="M527.347,772.523L757.493,1041.99L668.598,1117.91C662.461,1123.15 653.237,1122.43 647.996,1116.29L436.831,869.05C431.589,862.913 432.315,853.689 438.452,848.448L527.347,772.523Z"
          fillRule="nonzero"
        />
        <path
          d="M1293.43,829.72C1302.69,818.784 1302.65,802.749 1293.35,791.853L858.217,282.392C848.911,271.496 833.079,268.954 820.83,276.388L721.277,336.809C711.25,342.894 702.836,351.304 696.745,361.327L477.832,721.584C474.555,726.977 475.11,733.864 479.209,738.663L782.248,1093.47C786.333,1098.25 793.02,1099.89 798.849,1097.52L1189.96,938.984C1200.92,934.542 1210.63,927.507 1218.27,918.482L1293.43,829.72Z"
          fillRule="nonzero"
        />
        <g transform="matrix(0.649453,0.760401,-0.760401,0.649453,538.955,-833.522)">
          <path d="M1315.99,239.026C1315.99,199.708 1284.07,167.787 1244.75,167.787C1205.43,167.787 1173.51,199.708 1173.51,239.026L1173.51,443.61C1173.51,482.928 1205.43,514.849 1244.75,514.849C1284.07,514.849 1315.99,482.928 1315.99,443.61L1315.99,239.026Z" />
        </g>
        <g transform="matrix(0.649453,0.760401,-0.760401,0.649453,768.596,-898.292)">
          <path d="M1501.06,455.707C1501.06,416.389 1469.14,384.468 1429.82,384.468C1390.5,384.468 1358.58,416.389 1358.58,455.707L1358.58,660.291C1358.58,699.609 1390.5,731.53 1429.82,731.53C1469.14,731.53 1501.06,699.609 1501.06,660.291L1501.06,455.707Z" />
        </g>
        <path
          d="M622.087,935.896C639.709,911.29 634.047,877.058 609.441,859.437C584.836,841.815 550.604,847.477 532.982,872.083L622.087,935.896ZM107.014,1225.09C90.345,1250.35 97.311,1284.34 122.572,1301.01C147.834,1317.68 181.824,1310.71 198.492,1285.45L107.014,1225.09ZM532.982,872.083C483.743,940.838 473.226,989.975 383.965,1011.35L409.487,1117.93C549.842,1084.33 589.418,981.513 622.087,935.896L532.982,872.083ZM383.965,1011.35C323.608,1025.8 275.579,1042.71 230.796,1077.42C187.426,1111.04 151.008,1158.41 107.014,1225.09L198.492,1285.45C241.65,1220.04 269.815,1185.85 297.941,1164.05C324.655,1143.34 355.036,1130.97 409.487,1117.93L383.965,1011.35Z"
          fillRule="nonzero"
        />
      </g>
    </svg>
  );
}

export default PlugSolid;
